import React, { useState, useEffect, useRef } from "react";
import { SARIconThemeColor, setMobileCardBorderColor, setMobileTextColor } from "../../../utility";

const Swiper = ({ handleSelected, prices, currency }) => {
  const [options, setOptions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0); // Start with the middle item
  const containerRef = useRef(null);
  const isScrolling = useRef(false);
  const scrollTimeout = useRef(null);

  useEffect(() => {
    const array = prices.map((price) => ({
      price: price.price,
      old_price: price.old_price || "",
    }));

    setOptions(array);
  }, [prices]);

  useEffect(() => {
    if (options.length > 0) {
      handleSelected(options[currentIndex]);
    }
  }, [options, currentIndex]);

  useEffect(() => {
    if (containerRef.current) {
      const childHeight = containerRef.current.children[0].offsetHeight;
      const scrollPosition = childHeight * currentIndex - childHeight;
      containerRef.current.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }, [currentIndex]);

  const nextIndex = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % options.length);
  };

  const prevIndex = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? options.length - 1 : prevIndex - 1
    );
  };

  const handleScroll = (event) => {
    if (!isScrolling.current) {
      isScrolling.current = true;

      // Determine direction of scrolling
      const direction = event.deltaY > 0 || event.deltaX > 0 ? 1 : -1;

      // Clear previous timeout if exists
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      // Set new timeout to handle the scroll behavior
      scrollTimeout.current = setTimeout(() => {
        isScrolling.current = false;

        // Update the index based on scroll direction
        if (direction > 0) {
          nextIndex();
        } else {
          prevIndex();
        }
      }, 300); // Timeout to wait after the scroll stops
    }
  };

  const handleTouchStart = (event) => {
    // Capture initial touch position
    const touchStartY = event.touches[0].clientY;
    containerRef.current.dataset.touchStartY = touchStartY;
  };

  const handleTouchMove = (event) => {
    // Prevent default behavior to avoid page scroll
    event.preventDefault();
  };

  const handleTouchEnd = (event) => {
    // Calculate swipe direction based on touch start and end positions
    const touchEndY = event.changedTouches[0].clientY;
    const touchStartY = parseFloat(containerRef.current.dataset.touchStartY);
    const direction = touchEndY - touchStartY;

    if (direction > 0) {
      prevIndex();
    } else if (direction < 0) {
      nextIndex();
    }

    // Reset touch data
    containerRef.current.dataset.touchStartY = "";
  };

  const handleItemClick = (event, index) => {
    // Determine which part of the item was clicked
    const itemHeight = containerRef.current.children[0].offsetHeight;
    const clickY =
      event.clientY - containerRef.current.getBoundingClientRect().top;
    const clickPos = clickY / itemHeight;

    if (clickPos < 0.5) {
      prevIndex(); // Clicked on the upper half
    } else {
      nextIndex(); // Clicked on the lower half
    }
  };

  return (
    options.length > 0 && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          overflow: "hidden",
        }}
        onWheel={handleScroll}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          ref={containerRef}
          style={styles.container}
          className="price-swiper-container"
        >
          {options.map((option, index) => (
            <div
              key={index}
              style={{
                ...styles.priceOption,
                ...(currentIndex === index ? styles.selectedOption : {}),
              }}
              onClick={(e) => handleItemClick(e, index)}
            >
              <span>
                {option.old_price && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "red",
                      marginLeft: "1px", // To add some space between price and old_price
                    }}
                  >
                    {`  ${option.old_price}`}
                  </span>
                )}{" "}
                {`${option.price} `} {currency ? currency === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()}  className="mr-1" /> : currency : ""}
              </span>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    overflowY: "scroll",
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE 10+
    width: "100%",
    height: "90%", // Adjust as needed for your design
    textAlign: "center",
    scrollSnapType: "y mandatory",
    WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
  },
  priceOption: {
    flex: "0 0 auto",
    padding: "5px",
    margin: "2px 0",
    cursor: "pointer",
    fontSize: "16px",
    transition: "font-size 0.3s, color 0.3s",
    textAlign: "center",
    scrollSnapAlign: "center", // Center each item
    color: "#808080", // Different color for the selected item
  },
  selectedOption: {
    fontSize: "18px", // Larger font size for the selected item
    color:
      localStorage.getItem("theme") === "light" ||
      localStorage.getItem("backColor") === "#F2F1DC"
        ? "#000"
        : "#fff", // Different color for the selected item
  },
};

export default Swiper;
